type EcoScoreSVGProps = {
  cost: number | null
  costPer100g: number | null
  impactPoints?: string
  environmentalCostText?: string
}

import styles from "./EcoLabel.module.css"

const VIEW_BOX_WIDTH = 160
const VIEW_BOX_HEIGHT = 80 // fixed height base on Ecolabel design criteria

export const EcoScoreSVG = ({
  cost,
  costPer100g,
  impactPoints = "points d'impact",
  environmentalCostText = "Coût Environnemental",
}: EcoScoreSVGProps) => {
  const costPer100gText = `${costPer100g ?? 0}pts/100g`
  const textWidth = getMarianneFontTextWidth(costPer100gText) + 10
  const textHeight = 12 + 4
  const paddingX = 3

  const costRightEdgeX = VIEW_BOX_WIDTH - 15 // Right edge with some margin
  const costPer100gRightEdgeX = VIEW_BOX_WIDTH - 15
  const costPer100gY = 62
  const [beforeLast, lastWord] = (() => {
    const parts = environmentalCostText.toUpperCase().trim().split(" ")
    const last = parts.pop() || ""
    return [parts.join(" "), last]
  })()
  return (
    <svg
      width={VIEW_BOX_WIDTH}
      height={VIEW_BOX_HEIGHT}
      viewBox="0 0 154 77"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36.2 76.2C16.3 76.2 0.199997 59.1 0.199997 38.1C0.199997 17.1 16.4 0 36.2 0H148.2C151.1 0 153.5 2.4 153.5 5.4V70.7C153.5 73.7 151.1 76.1 148.2 76.1H36.2V76.2Z"
        fill="white"
      />
      <text
        x={costRightEdgeX - paddingX}
        y={15}
        fill="#000000"
        textAnchor="end"
        fontSize="7px"
        className={styles.environmentalCostText}
      >
        <tspan>{beforeLast} </tspan>
        <tspan fontWeight="bold">{lastWord}</tspan>
      </text>
      <text
        x={costRightEdgeX}
        y={42}
        fill="#000000"
        textAnchor="end"
        fontSize="32px"
        className={styles.costText}
      >
        {cost}
      </text>
      <path
        d="M36.2 72.8C18.2 72.8 3.6 57.2 3.6 38.1C3.6 19 18.2 3.4 36.2 3.4H148.1C149.2 3.4 150 4.3 150 5.4V70.7C150 71.8 149.1 72.7 148.1 72.7H36.2V72.8Z"
        strokeWidth="0.9946"
        stroke="#000000"
        strokeMiterlimit="10"
        fill="none"
      />
      <path
        stroke="#000000"
        fill="#000000"
        d="M7.7998 20.9004C8.9998 20.9004 10.1002 21.0002 11.2002 21.2002V24.0996H7.7998V27.5H11.2002V30.9004H14.5996V27.5H18V30.9004H21.4004V27.5H24.7998V30.9004H21.4004V34.2998H24.7998V37.5996H27.5996C27.7996 38.5996 27.9004 39.6999 27.9004 40.7998V40.9004H24.7998V44.2998H27.5C27.3 45.4998 26.9996 46.6002 26.5996 47.7002C26.1996 48.9 25.5999 49.9998 25 51.0996C25 51.2996 24.8998 51.4 24.7998 51.5C24.1998 52.6 23.4 53.6 22.5 54.5C22.1001 54.7999 21.8003 55.2 21.4004 55.5C20.5004 56.3 19.3998 57.0998 18.2998 57.7998C18.1998 57.8998 18.1 57.9 18 58C16.9 58.6 15.7996 59.1996 14.5996 59.5996C13.4997 59.9995 12.4 60.3 11.2002 60.5C10.1002 60.7 8.9998 60.7998 7.7998 60.7998H7.28906C2.78912 54.4998 0 46.7999 0 38.5C2.46115e-07 32.3 1.19981 26.4998 3.7998 21.2998C3.9998 21.2998 4.30039 21.2002 4.40039 21.2002C5.50022 21.0002 6.60001 20.9004 7.7998 20.9004ZM11.2002 51.2002H14.5996V47.7998H11.2002V51.2002ZM14.5996 34.2998H11.2002V41H14.5996V37.5996H18V30.9004H14.5996V34.2998ZM18 41H21.4004V37.7002H18V41ZM4.40039 37.5996H7.7998V34.2998H4.40039V37.5996ZM31.5996 34H28.2002V30.5996H31.5996V34ZM14.5996 24.0996V27.5H11.2002V24.0996H14.5996ZM21.4004 27.5H18V24.0996H21.4004V27.5ZM28.2998 24.2002H24.9004V20.7998H28.2998V24.2002ZM31.7998 17.4004H28.4004V14H31.7998V17.4004Z"
      />
      <text
        x={costPer100gRightEdgeX - paddingX}
        y={50}
        fill="#000000"
        textAnchor="end"
        fontSize="8px"
        className={styles.pointsText}
      >
        {impactPoints}
      </text>
      {/* Background rectangle for costPer100g - positioned behind text */}
      {costPer100g && (
        <>
          <rect
            x={costPer100gRightEdgeX - textWidth}
            y={costPer100gY - textHeight / 2}
            width={textWidth}
            height={textHeight}
            fontSize="12px"
            rx="3"
            ry="3"
            fill="#595959"
            stroke="#000000"
          />
          <text
            x={costPer100gRightEdgeX - paddingX}
            y={costPer100gY}
            textAnchor="end"
            dominantBaseline="middle"
            fontSize="12px"
            fill="white"
          >
            {costPer100gText}
          </text>
        </>
      )}
    </svg>
  )
}

const getMarianneFontTextWidth = (text: string): number => {
  let width = 0
  for (const char of text) {
    switch (char) {
      case "0":
        width += 6.6
        break
      case "1":
        width += 5
        break
      case "2":
        width += 6.8
        break
      case "3":
        width += 7
        break
      case "4":
        width += 7.2
        break
      case "5":
        width += 6.8
        break
      case "6":
        width += 7.2
        break
      case "7":
        width += 6.4
        break
      case "8":
        width += 7.2
        break
      case "9":
        width += 7.2
        break
      case "p":
        width += 6.8
        break
      case "t":
        width += 4.2
        break
      case "s":
        width += 5.6
        break
      case "g":
        width += 6.8
        break
      case "o":
        width += 6.8
        break
      case "/":
        width += 3.6
        break
      case ".":
        width += 3
        break
      default:
        width += 6.8
    }
  }
  return width
}
